import {Component, OnInit, ViewRef} from '@angular/core';

import {HsDialogComponent, HsDialogContainerService} from 'hslayers-ng';

import {MetadataDialogService} from './metadata-dialog.service';

export type DatasetDescriptor = {
  id: string;
  coverage?: string;
  desc?: string;
  link?: string;
  lod?: string;
  source?: string;
  title?: string;
  update?: string;
};

@Component({
  selector: 'pra-metadata-dialog',
  templateUrl: './metadata-dialog.component.html',
})
export class MetadataDialogComponent implements HsDialogComponent, OnInit {
  viewRef: ViewRef;
  data: DatasetDescriptor;

  constructor(
    public hsDialogContainerService: HsDialogContainerService,
    public metadataDialogService: MetadataDialogService
  ) {}

  ngOnInit() {
    const newData = this.metadataDialogService.loadDatasetMetadata(
      this.data.id
    );
    this.data = {...this.data, ...newData};
  }

  close(): void {
    this.hsDialogContainerService.destroy(this);
  }
}
